<template>
  <div class="loader" :id="id">
    <img src="./../assets/loader-icon.svg" alt="Loading..." class="loader-icon">
    <h4>{{ text }}</h4>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    id: { type: String },
    text: { type: String }
  }
}
</script>

<style scoped>
.loader {
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
}
.loader-icon {
  display: inline-block;
}
h4 {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue